module.exports = __webpack_public_path__ + "img/cxample_13.d5f3f240.png";